// @flow
import React, { Component } from 'react';
import queryString from 'query-string';
import { type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { type State } from 'store';
import storage, { keys } from 'lib/storage';
import BadRequest from 'pages/errors/BadRequest';
import { UserActions, CartActions, WishActions } from 'store/actionCreators';
import * as sso from 'lib/sso';

type Props = {} & ContextRouter;

type SSOCallbackState = {
  loading: boolean,
  error: ?string,
};

class SSOCallback extends Component<Props, SSOCallbackState> {
  state = {
    loading: true,
    error: null,
  };

  initialize = async () => {
    const query = queryString.parse(this.props.location.search);
    const { code, state, error } = query;

    if (error) {
      this.setState({
        loading: false,
        error: `SSO 인증 오류: ${error}`,
      });
      return;
    }

    if (!code) {
      this.setState({
        loading: false,
        error: 'Authorization code가 없습니다.',
      });
      return;
    }

    try {
      // Authorization Code를 토큰으로 교환
      const response = await sso.exchangeCodeForToken(code, state || '');
      
      if (response.success && response.user) {
        const { user } = response;
        
        // Redux 스토어에 사용자 정보 저장
        UserActions.setUser(user);
        
        // 로컬 스토리지에 사용자 정보 저장
        storage.set(keys.user, user);
        
        // 장바구니 및 위시리스트 로드
        await CartActions.getCart();
        await WishActions.getWish();
        
        // state에서 returnUrl 파싱
        let returnUrl = '/';
        try {
          if (state) {
            const stateObj = JSON.parse(state);
            returnUrl = stateObj.returnUrl || '/';
          }
        } catch (e) {
          console.warn('Failed to parse state:', e);
        }
        
        // 리다이렉트
        this.props.history.push(returnUrl);
      } else {
        throw new Error('토큰 교환에 실패했습니다.');
      }
    } catch (e) {
      console.error('SSO callback error:', e);
      this.setState({
        loading: false,
        error: e.message || 'SSO 로그인 처리 중 오류가 발생했습니다.',
      });
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const { loading, error } = this.state;

    if (error) {
      return <BadRequest />;
    }

    if (loading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
          }}
        >
          <div>SSO 로그인 처리 중...</div>
        </div>
      );
    }

    return null;
  }
}

export default connect(
  ({ user }: State) => ({
    logged: user.logged,
  }),
  () => ({}),
)(SSOCallback);



// WEBPACK FOOTER //
// ./src/containers/etc/SSOCallback.js